import { Select as AntSelect, SelectProps } from 'antd';

import Select from './Select';

export const { Option } = AntSelect;

export type { SelectProps };

export default Select;
